<template>
  <v-flex xs12>
    <div v-show="error !== ''">
      <v-alert
        :value="true"
        type="error">
        {{ error }}
      </v-alert>
    </div>

    <div v-show="loading" class="text-xs-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialog"
          max-width="290"
        >
          <v-card>
            <v-card-title class="headline">{{dialog_title}}</v-card-title>

            <v-card-text>
              {{dialog_content}}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color='info'
                @click="dialog = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-data-table
          v-show="!error && !loading"
          :headers="headers"
          :items="travels"
          class="elevation-1"
          dark
          hide-actions
          sort-by="from"
        >
        <template v-slot:items="props" >
          <td>{{ num2date(props.item.from).format("MM/DD") }}</td>
          <td>{{ num2date(props.item.until).format('MM/DD') }}</td>
          <td>{{ props.item.place }}</td>
          <td>{{ props.item.purpose }}</td>
          <td>
            <v-icon
              small
              v-if="num2date(props.item.from).isSameOrAfter($moment(), 'day')"
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </template>
  </v-flex>
</template>

<script>
export default {
  async created() {
    try {
      let lodgings = await this.api('lodging_index', {})
      this.travels = lodgings.payload.filter(e => e.from >= this.date2num(this.$moment()))
    }
    catch(e) {
      this.error = e.name + ': ' + e.message
    }finally{
      this.loading = false
    }
  },
  methods: {
    async deleteItem(item){
      try{
        this.loading = true
        let result = await this.api('lodging_delete', {target: item.id})
        if(result.payload.result == "success"){
          this.travels.splice(this.travels.indexOf(item),1)
        }else{
          this.error = "外泊届の消去に失敗しました"
        }
      }catch(e) {
        this.error = e.name + ': ' + e.message
      }finally{
        this.loading = false
      }
    },
  },
  data () {
    return {
      user: localStorage.user || "",
      error: "",
      dialog: false,
      dialog_content: '',
      dialog_title: '',
      loading: true,
      travels: [],
      headers: [
        {
          text: '出発日',
          align: 'left',
          sortable: true,
          value: 'from'
        },
        {
          text: '帰館日',
          align: 'left',
          sortable: true,
          value: 'until'
        },
        {
          text: '宿泊先',
          value: 'place',
          sortable:true
        },
        {
          text: '目的',
          value: 'purpose',
          sortable:true
        },
        {
          text: '消去',
          value: 'action',
          sortable: false
        },
      ],
    }
  },
}
</script>
